module.exports = __webpack_public_path__ + "static/media/icon_search.95a687f1.svg";